__webpack_require__.p = "https://gamma.na.safety-genie.whs.amazon.dev/";